import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { PageTheme } from '@helpers/themeEnum';
import { paragraph, paragraphLarge } from '@helpers/typography';
import Button from '@stories/Components/Buttons/GeneralButton/Button';
import { ButtonStyles } from '@stories/Components/Buttons/GeneralButton/Button.styles';
import { DropdownStyles } from '@stories/Components/Dropdown/Dropdown.styles';
import { rgba } from 'polished';
import styled from 'styled-components';
const MobileToggleButton = styled.div `

  ${ButtonStyles.Button} {
    width: 100%;
    justify-content: center;
    height: 56px;
  }

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const Container = styled.div `

  --checkColor: ${rgba(brand.blue.base, 0.5)};

  [data-page-theme=${PageTheme.Orange}] & {
    --checkColor: ${rgba(brand.orange.base, 0.5)};
  }

  [data-page-theme=${PageTheme.Green}] & {
    --checkColor: ${rgba(brand.green.base, 0.5)};
  }

  [data-page-theme=${PageTheme.Blue}] & {
    --checkColor: ${rgba(brand.blue.base, 0.5)};
  }

  [data-page-theme=${PageTheme.Yellow}] & {
    --checkColor: ${rgba(brand.yellow.base, 0.5)};
  }

  @media ${until(Device.TabletLarge)} {
    display: flex;
    flex-direction: column;
    position: fixed;
    justify-content: flex-end; 
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    height: 100dvh;
    border-radius: unset;
    padding-left: 17px;
    padding-right: 17px;
    transform: translateX(100%);
    opacity: 0;
    background-color: ${rgba(brand.black, 0.9)};
    ${transition('transform opacity')}

    &[data-visible-mobile="true"] {
      transform: translateX(0px);
      opacity: 1;
    }

    ${DropdownStyles.Container} {
      place-content: space-between;
      padding: 0 24px;
      margin-bottom: 16px;
      width: 100%;

      svg {
        right: 24px;
      }
    }

    ${DropdownStyles.Select} {
      width: 100%;
      padding-right: 15px;
    }
  }

`;
const FilterArea = styled.div `
  display: flex;
  gap: ${fluid(0, 48)};
  align-items: center;

  @media ${until(Device.TabletLarge)} {
    flex-direction: column;
    background-color: ${brand.white};
    width: 100%;
    height: calc(100dvh - 35%);
    border-radius: 25px 25px 0 0;
    padding: 24px 12px 24px 20px;
  }
`;
const MobileTitle = styled.span `
  ${fonts.montserrat.medium};
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 19px;

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const DesktopSortBy = styled.div `
  flex: 0 1 375px;

  ${DropdownStyles.Container} {
    border: none;
    height: 60px;
    width: 100%;
    max-width: 375px;
    place-content: flex-start;
    overflow: hidden;
    padding-right: 20px;
  }

  ${DropdownStyles.Select} {
    padding-right: 40px;
    width: 100%;

    &:focus {
      outline-offset: -1px;
    }
  }

  @media ${until(Device.TabletLarge)} {
    display: none;
  }
`;
const MobileSortBy = styled.div `
  width: 100%;
  padding-right: 8px;

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const Title = styled.div `
  ${paragraphLarge}
  ${fonts.montserrat.medium}
  margin-bottom: 12px;
`;
const FilterList = styled.div `
  position: relative;
  flex: 0 1 400px;

  @media ${until(Device.TabletLarge)} {
    display: flex;
    flex-direction: column;    
    height: 35dvh;
    margin-bottom: 40px;
    width: 100%;
  }
`;
const CatButton = styled.button `
  ${ButtonReset};
  ${fonts.montserrat.regular};
  font-size: 20px;
  line-height: 27px;
  height: 60px;
  background-color: ${brand.white};
  width: 100%;
  max-width: 400px;
  text-align: left;
  padding: 5px 55px 5px 40px;
  border-radius: 100px;
  position: relative;

  @media ${until(Device.TabletLarge)} {
    display: none;
  }

  &:focus-visible {
    outline: auto;
    outline-offset: 3px;
    outline-color: var(--textColor);
  }

  &[data-filter-open='true'] {
    border-radius: 30px 30px 0 0;
    svg {
      transform: translateY(-50%) rotate(-90deg);
    }
  }

  svg {
    ${transition('transform')};
    position: absolute;
    top: 50%;
    right: 32px;
    transform: translateY(-50%) rotate(90deg);
    width: 10px;
    height: 10px;
  }
`;
const CatList = styled.div `
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
  background-color: ${brand.white};
  padding: 9px 16px 0 32px;
  
  max-height: 315px;
  width: 100%;
  overflow: hidden;

  @media ${from(Device.TabletLarge)} {
    border-radius: 0 0 30px 30px;

    &:after {
      content: '';
      position: absolute;
      bottom: 30px;
      left: 0;
      width: 100%;
      height: 30px;
      background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
      z-index: 1;
    }
  }

  &[data-filter-open='false'] {
    display: none;
  }

  @media ${until(Device.TabletLarge)} {
    display: flex;
    position: relative;
    top: auto;
    left: auto;
    min-width: 100%;
    max-height: 100%;
    padding: 0;

    &[data-filter-open='false'] {
      display: flex;
    }
  }
`;
const CatListInner = styled.div `  
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  width: 100%;
  margin-right: calc(var(--sitePadding) * -1);
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar-track {
    background-color: ${brand.white};
  }

  &::-webkit-scrollbar {
    background-color: ${brand.white};
    height: 5px;
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--checkColor);
    border-radius: 5px;
    cursor: pointer;
  }

  @media ${from(Device.TabletLarge)} {
    margin-bottom: 30px;
  }
`;
const FilterButton = styled.button `
  ${ButtonReset};
  ${fonts.montserrat.regular}
  font-size: ${fluid(16, 18)};
  line-height: 32px;
  padding: 0 18px 0 44px;
  position: relative;
  text-align: left;

  &:focus-visible {
    outline: auto;
    outline-offset: 0;
    outline-color: var(--textColor);
  }

  svg {
    ${transition('opacity')};
    position: absolute;
    top: 9px;
    left: 9px;
    width: 14px;
    height: 14px;
    color: ${brand.black};
    opacity: 0;
  }

  &:before {
    ${transition('background-color')};
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 30px;
    height: 30px;
    border: 1px solid var(--checkColor);
    border-radius: 2px;
  }

  &[data-active='true'] {
    svg {
      opacity: 1;
    }
    
    &:before {
      background-color: var(--checkColor);
    }
  }


  &:last-of-type {
    margin-bottom: 20px;
  }

`;
const Clear = styled(Button) `
  &&& {
    --brandColour: ${brand.grey.grey16};
    --hoverColour: var(--primaryPageThemeColor);
  }

  position: relative;
  display: inline-flex;
  align-items: center;
  height: 50px;
  margin-right: 32px;

  ${ButtonStyles.ButtonInner} {
    display: inline-block;
  }

  ${ButtonStyles.Text} {
    ${fonts.montserrat.medium}

    + div {
      padding: 0;
    }
  }

  svg {    
    width: 14px;
  }
`;
const Close = styled.div `
  position: absolute;
  bottom: 67%;
  right: 17px;
  width: 40px;
  height: 40px;
  background-color: ${brand.white};
  border-radius: 100000px;
  display: flex;
  place-items: center;
  place-content: center;

  @media ${from(Device.TabletLarge)} {
    display: none;
  }

  svg {
    width: 18px;
    height: 18px;
    transform: rotate(45deg);
  }
`;
const Listing = styled.div `
  ${baseGrid};
  grid-template-columns: 1fr;
  row-gap: ${fluid(40, 72)};

  @media ${from(Device.TabletSmall)} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media ${from(Device.TabletLarge)} {
    grid-template-columns: repeat(4, 1fr);
  }
`;
const ListingTotals = styled.div `
  flex: 1 0 auto;

  @media ${until(Device.TabletLarge)} {
    display: none;
  }
`;
const ListingTotalsText = styled.p `
  ${paragraph};
  ${fonts.montserrat.light};
  margin-bottom: 0;
  text-align: center;

  span {
    ${fonts.montserrat.medium};
  }

  @media ${from(Device.TabletSmall)} {
    text-align: center;
  }
`;
const ListingTotalsMobile = styled.div `
  margin-top: 48px;

  @media ${from(Device.TabletSmall)} {
    display: none;
  }
`;
const SelectedFilters = styled.div `
  margin-top: 32px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  @media ${until(Device.TabletLarge)} {
    display: none;
  }
`;
const SelectedFilterButton = styled(Button) `

  ${ButtonStyles.Text} {
    white-space: nowrap;
  }

  &[data-button-size='small'] {
    ${ButtonStyles.Text} {
      ${fonts.montserrat.regular}
      font-size: 18px;
      line-height: 28px;      
    }
  }

  svg {    
    width: 12px;
  }
`;
const ApplyFilter = styled.div `
  width: 100%;
  padding-right: 8px;

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const ApplyFilterBtn = styled(Button) `
  width: 100%;
  justify-content: center;
`;
export const BlogFilterStyles = {
    Container,
    Clear,
    Close,
    Title,
    FilterArea,
    CatButton,
    CatList,
    CatListInner,
    FilterList,
    FilterButton,
    DesktopSortBy,
    MobileSortBy,
    MobileTitle,
    MobileToggleButton,
    Listing,
    ListingTotals,
    ListingTotalsMobile,
    ListingTotalsText,
    SelectedFilters,
    SelectedFilterButton,
    ApplyFilter,
    ApplyFilterBtn,
};
